import '@toast-ui/editor/dist/toastui-editor-viewer.css';
import { Viewer } from '@toast-ui/react-editor';

export const ToastViewer = ({ content }: { content: string }) => {
  return (
    <div>
      <Viewer
        initialValue={content}
        customHTMLRenderer={{
          htmlBlock: {
            iframe(node: any) {
              return [
                {
                  type: 'openTag',
                  tagName: 'div',
                  outerNewLine: true,
                  attributes: { class: 'youtubeWrapper' },
                },
                {
                  type: 'openTag',
                  tagName: 'iframe',
                  outerNewLine: true,
                  attributes: node.attrs,
                },
                { type: 'html', content: node.childrenHTML },
                {
                  type: 'closeTag',
                  tagName: 'iframe',
                  outerNewLine: false,
                },
                {
                  type: 'closeTag',
                  tagName: 'div',
                  outerNewLine: false,
                },
              ];
            },
          },
        }}
      />
    </div>
  );
};
